import { createContext } from "react";

const CustomComponentsCtx = createContext(null);

export default CustomComponentsCtx;
